import { datadogRum } from "@datadog/browser-rum";

const logErrorToDatadog = (error: Error, context: any, id: any) => {
  datadogRum.setGlobalContextProperty("id", id);
  datadogRum.setGlobalContextProperty("context", context);

  datadogRum.addError(error);
};

export const logError = (...args: [error: Error, context: any, id: any]) => {
  logErrorToDatadog(...args);

  console.error(args[0]);
};
